import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { UserEditErrorPageBaseComponent } from '@resident-nx/shared';
import { ErrorScreenComponent } from '../../../../atoms/error-screen/error-screen.component';
import { AsyncPipe } from '@angular/common';

@Component({
  standalone: true,
  selector: 'rs-web-user-profile-edit-error',
  imports: [TranslateModule, ErrorScreenComponent, AsyncPipe],
  templateUrl: './user-profile-edit-error.component.html',
  styleUrl: './user-profile-edit-error.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserProfileEditErrorComponent extends UserEditErrorPageBaseComponent {}
